export const isValidPassword = (password: string) => {
  if (typeof password !== "string") return false;
  return password.length >= 8;
};
